import { render, staticRenderFns } from "./WhSubButton.vue?vue&type=template&id=35c37616&scoped=true&"
import script from "./WhSubButton.vue?vue&type=script&lang=js&"
export * from "./WhSubButton.vue?vue&type=script&lang=js&"
import style0 from "./WhSubButton.vue?vue&type=style&index=0&id=35c37616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c37616",
  null
  
)

export default component.exports